import { useAtomValue, useExodus } from '@exodus/headless-ui';
import { useCallback } from 'react';
import { originAtom } from '../../atoms/index.js';
const useTrackConfigureAsset = () => {
    const exodus = useExodus();
    const origin = useAtomValue(originAtom);
    return useCallback(() => {
        return exodus.analytics.track({
            event: 'ExchangeConfigureAssetSwap',
            properties: {
                origin,
            },
        });
    }, [origin, exodus.analytics]);
};
export default useTrackConfigureAsset;
